import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import App from "./App.js";
import store from "./store";
// import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const root = ReactDOM.createRoot(document.getElementById("root"));

const THEME = createTheme({
  typography: {
    fontFamily: `"Arimo", sans-serif`,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
});

root.render(
  <ThemeProvider theme={THEME}>
    <Provider store={store.store}>
      {/* <GoogleReCaptchaProvider
        reCaptchaKey={process.env.REACT_APP_GOOGLE_CAPTCHA_KEY}
      > */}
      <App />
      {/* </GoogleReCaptchaProvider> */}
    </Provider>
  </ThemeProvider>
);
